export const ACTION_AUTH = 'ACTION_AUTH';
export const SET_ACCOUNT_TYPE = 'SET_ACCOUNT_TYPE';
export const ACTION_CLEAR_AUTH = 'ACTION_CLEAR_AUTH';

export const ACTION_SEARCH = 'ACTION_SEARCH';
export const ACTION_SET_AID_INFO = 'ACTION_SET_AID_INFO';
export const ACTION_CLEAR_SEARCH = 'ACTION_CLEAR_SEARCH';

export const ACTION_SET_PARTNER_EXPORT = 'ACTION_SET_PARTNER_EXPORT';
export const ACTION_CLEAR_PARTNER_EXPORT = 'ACTION_CLEAR_PARTNER_EXPORT';
